<template>
  <div class="setting-main-container">
    <form action="" @submit.prevent="submitCustomerData">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('general.internal_process') }}</h3>
        </div>
        <div class="row  mb-4">
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.rate_of_prepayment') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.rate_of_prepayment.$error}"
                v-model="formData.rate_of_prepayment"
                v-bind="defaultInput"
                disabled="disabled"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.rate_of_prepayment.$error">
              <span v-if="!$v.formData.rate_of_prepayment.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.kibor_amount') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                v-model="formData.kibor_amount"
                v-bind="defaultInput"
                disabled="disabled"
                class="input-field"
              />
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.spread') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.spread.$error}"
                v-model="spreadAmount"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.spread.$error">
              <span v-if="!$v.formData.spread.required" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.financing_ratio') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.margin_rate.$error}"
                v-model="formData.margin_rate"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.margin_rate.$error">
              <span v-if="!$v.formData.margin_rate.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.transaction_fees') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.transaction_fees.$error}"
                v-model="formData.transaction_fees"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.transaction_fees.$error">
              <span v-if="!$v.formData.transaction_fees.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.longitude') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <input
                :class="{'invalid' : $v.formData.longitude.$error}"
                v-model.number="formData.longitude"
                type="number"
                step="any"
                class="input-field"
              >
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.latitude') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <input
                :class="{'invalid' : $v.formData.latitude.$error}"
                v-model.number="formData.latitude"
                type="number"
                step="any"
                class="input-field"
              >
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.price_cushion') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.price_cushion.$error}"
                v-model="formData.price_cushion"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.price_cushion.$error">
              <span v-if="!$v.formData.price_cushion.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.price_cushion.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
          <div class="form-group col-md-6 mb-6">
            <label class="input-label">{{ $tc('general.cost_cushion') }}</label><span class="text-danger"> * </span>
            <div class="base-input">
              <money
                :class="{'invalid' : $v.formData.cost_cushion.$error}"
                v-model="formData.cost_cushion"
                v-bind="defaultInput"
                class="input-field"
              />
            </div>
            <div v-if="$v.formData.cost_cushion.$error">
              <span v-if="!$v.formData.cost_cushion.required" class="form-group__message text-danger">{{ $t('validation.required') }}</span>
              <span v-if="!$v.formData.cost_cushion.between" class="form-group__message text-danger">{{ $t('validation.enter_valid_tax_rate') }}</span>
            </div>
          </div>
        </div>
        <div class="row  mb-4">
          <div class="col-md-12 input-group">
            <base-button
              :loading="isLoading"
              :disabled="isLoading"
              icon="save"
              color="theme"
              type="submit"
            >
              {{ $tc('profile.business_status.save') }}
            </base-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions } from 'vuex'
const { required, between } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false,
      formData: {
        rate_of_prepayment: 0,
        spread: 0,
        margin_rate: 0,
        kibor_amount: 0,
        transaction_fees: 0,
        longitude: 0,
        latitude: 0,
        price_cushion: 0,
        cost_cushion: 0
      },
      defaultInput: {
        decimal: '.',
        thousands: ',',
        prefix: '% ',
        precision: 2,
        masked: false
      },
      coordinateInput: {
        decimal: '.',
        thousands: '',
        prefix: '',
        precision: 15,
        masked: false
      }
    }
  },
  validations () {
    return {
      formData: {
        rate_of_prepayment: {
          required,
          between: between(0, 100)
        },
        spread: {
          required,
          between: between(0, 100)
        },
        margin_rate: {
          required,
          between: between(0, 100)
        },
        transaction_fees: {
          required,
          between: between(0, 100)
        },
        longitude: {
          required
        },
        latitude: {
          required
        },
        price_cushion: {
          required,
          between: between(0, 100)
        },
        cost_cushion: {
          required,
          between: between(0, 100)
        }
      }
    }
  },
  computed: {
    spreadAmount: {
      get: function () {
        return this.formData.spread
      },
      set: function (newValue) {
        this.formData.spread = newValue
        this.formData.rate_of_prepayment = this.formData.kibor_amount + newValue
      }
    }
  },
  created () {
    this.getCompanyImpactOnAccount()
    this.loadData()
  },
  mounted () {},
  methods: {
    ...mapActions('companyImpactOthers', [
      'addCompanyImpactOthers',
      'fetchCompanyImpactAccount',
      'getImpact'
    ]),
    ...mapActions('funderDashboard', [
      'loadData'
    ]),
    ...mapActions('customer', [
      'fetchViewCustomer'
    ]),
    async getCompanyImpactOnAccount () {
      let response
      if (this.viewCustomer && this.viewCustomer.default_company_id && localStorage.getItem('selectedCompany')) {
        let data = {
          company_id: localStorage.getItem('selectedCompany'),
          guest_company_id: this.viewCustomer.default_company_id
        }
        response = await this.getImpact(data)
      } else {
        let customerResponse = await this.fetchViewCustomer(this.$route.params.id)
        if (customerResponse.data && customerResponse.data.customer.default_company_id) {
          let data = {
            company_id: localStorage.getItem('selectedCompany'),
            guest_company_id: customerResponse.data.customer.default_company_id
          }
          response = await this.getImpact(data)
        }
      }
      if (response.data) {
        if (response.data.rate_of_prepayment) {
          this.formData.rate_of_prepayment = Number(response.data.rate_of_prepayment)
        }
        if (response.data.margin_rate) {
          this.formData.margin_rate = Number(response.data.margin_rate)
        }
        if (response.data.transaction_fees) {
          this.formData.transaction_fees = Number(response.data.transaction_fees)
        }
        if (response.data.spread) {
          this.formData.spread = Number(response.data.spread)
        }
        if (response.data.longitude) {
          this.formData.longitude = Number(response.data.longitude)
        }
        if (response.data.latitude) {
          this.formData.latitude = Number(response.data.latitude)
        }
        if (response.data.price_cushion) {
          this.formData.price_cushion = Number(response.data.price_cushion)
        }
        if (response.data.cost_cushion) {
          this.formData.cost_cushion = Number(response.data.cost_cushion)
        }
      }
    },
    async submitCustomerData () {
      this.$v.formData.$touch()
      if (this.$v.$invalid) {
        return true
      }
      this.isLoading = true
      const rateOfPrepayment = Number(this.formData.spread) + Number(this.formData.kibor_amount)
      let data = {
        guest_user_id: this.$route.params.id,
        rate_of_prepayment: rateOfPrepayment.toFixed(2),
        margin_rate: this.formData.margin_rate.toFixed(2),
        transaction_fees: this.formData.transaction_fees.toFixed(2),
        spread: this.formData.spread.toFixed(2),
        longitude: this.formData.longitude,
        latitude: this.formData.latitude.toString(),
        price_cushion: this.formData.price_cushion.toFixed(2),
        cost_cushion: this.formData.cost_cushion.toFixed(2)
      }

      let response = await this.addCompanyImpactOthers(data)
      if (response.data.result) {
        window.toastr['success'](this.$t('customers.updated_message'))
        this.isLoading = false
      }
    },
    async loadData (params) {
      params = {
        ...this.formData
      }
      let res = await this.$store.dispatch('funderDashboard/loadData', params)
      this.formData.kibor_amount = res.data.kiborAmount
      this.isLoaded = true
    }
  }
}
</script>
